export default "__VITE_ASSET__f8f96caa__"